import { Layout } from 'antd';

import styled, { css } from 'styled-components';
import { cssMediaBreakpoints } from '../../../utils/responsiveQuery/breakpoints';
import LogoIcon from './icons/LogoIcon';
import LogoTextIcon from './icons/LogoTextIcon';

export const LogoContainer = styled.div<LogoTextProps>`
  transition: margin 0.3s;
  height: 64px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;

interface LogoTextProps {
  $collapsed: boolean;
}

export const Logo = styled(LogoIcon)`
  margin-right: 9px;
  min-width: 29px;
`;

export const LogoText = styled(LogoTextIcon)<LogoTextProps>`
  visibility: ${p => (p.$collapsed ? 'hidden' : 'visible')};
  opacity: ${p => (p.$collapsed ? '0' : '1')};
  transition: opacity 0.5s;
`;

export const SidebarInner = styled.div`
  position: sticky;
  top: 0;
`;

export const Sidebar = styled(Layout.Sider)`
  background: ${p => p.theme.backgroundColor};
  border: 1px solid ${p => p.theme.borderColor};
  ${cssMediaBreakpoints.mobile} {
    ${props =>
      props.collapsed &&
      css`
        opacity: 0;
        visibility: hidden;
      `};
  }
`;
